document.addEventListener('DOMContentLoaded', () => {
    // ページ内のすべての a タグを取得
    document.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href');
      
      // hrefが空、ページ内リンク（#）、javascript:、またはShopifyの決済チェックアウト用リンク等は除外
      if (!href || href.startsWith('#') || href.startsWith('javascript:') || href.includes('/checkout')) return;

      try {
        // リンク先が「現在のショップのドメイン」と異なる外部サイトの場合のみ処理
        const targetUrl = new URL(link.href);
        if (targetUrl.hostname !== window.location.hostname) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer'); // セキュリティ・パフォーマンス対策
        }
      } catch (e) {
        // 相対パス（/products/ や /pages/ など）でURLオブジェクト作成に失敗した場合は内部リンクのため無視
      }
    });
  });